var l1 = {
    code: 'ar-dz',
    week: {
        dow: 0,
        doy: 4, // The week that contains Jan 1st is the first week of the year.
    },
    direction: 'rtl',
    buttonText: {
        prev: 'السابق',
        next: 'التالي',
        today: 'اليوم',
        year: 'سنة',
        month: 'شهر',
        week: 'أسبوع',
        day: 'يوم',
        list: 'أجندة',
    },
    weekText: 'أسبوع',
    allDayText: 'اليوم كله',
    moreLinkText: 'أخرى',
    noEventsText: 'أي أحداث لعرض',
};

export { l1 as default };
